import React from "react";
import { Loader2, FileDown } from "lucide-react";

/**
 * Full-screen overlay shown while a PDF is being generated server-side and downloaded.
 * Renders nothing when `open` is false.
 *
 * Props:
 *  - open: bool
 *  - title?: string  — main label (default: "Generazione PDF in corso…")
 *  - subtitle?: string — small caption
 */
export default function PdfDownloadOverlay({ open, title, subtitle }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[70] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      data-testid="pdf-download-overlay"
      role="alertdialog"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="bg-white rounded-2xl border-[1.5px] border-black px-6 py-5 max-w-sm w-full shadow-2xl flex items-center gap-4">
        <div className="relative shrink-0">
          <div className="w-12 h-12 rounded-2xl bg-[#ff5a00] flex items-center justify-center">
            <FileDown className="w-6 h-6 text-white" />
          </div>
          <Loader2 className="w-5 h-5 absolute -bottom-1 -right-1 text-[#ff5a00] animate-spin bg-white rounded-full" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-base">{title || "Generazione PDF in corso…"}</div>
          <div className="text-xs text-neutral-500 mt-0.5">
            {subtitle || "Attendi qualche secondo. Non chiudere la pagina."}
          </div>
        </div>
      </div>
    </div>
  );
}
